/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Multica_Kb8Inputs */

const en_mk_cmp_multica_kb8 = /** @type {(inputs: Mk_Cmp_Multica_Kb8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not our focus; agents here do office work.`)
};

const id_mk_cmp_multica_kb8 = /** @type {(inputs: Mk_Cmp_Multica_Kb8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukan fokus kami; agen di sini mengerjakan pekerjaan kantor.`)
};

/**
* | output |
* | --- |
* | "Not our focus; agents here do office work." |
*
* @param {Mk_Cmp_Multica_Kb8Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_multica_kb8 = /** @type {((inputs?: Mk_Cmp_Multica_Kb8Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Multica_Kb8Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_multica_kb8(inputs)
	return en_mk_cmp_multica_kb8(inputs)
});